import { notifications } from '@mantine/notifications';
import { useMutation } from '@tanstack/react-query'

export const mutateAdCreate = () => {

    const mutation = useMutation({
        mutationKey: ['ad-create'],
        mutationFn: async (formData) => {
            const res = await axios.post(route('studio.editor.api.ads.store'), formData);
            return res;
        },
        onSuccess: async () => {
            notifications.show({
                color: 'green',
                title: 'Success',
                message: 'Created',
              })
        },
        onError: async ({ response }) => {

            notifications.show({
                color: 'red',
                title: 'Error',
                message: response?.data?.message || "",
              })
        }
    });

    return mutation;
}